/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function () {
  "use strict";

  // Minimum cart value in cents (Rs 150 = 15000 cents)
  var MINIMUM_CART_VALUE = 15000;
  var MINIMUM_CART_VALUE_DISPLAY = 150;
  var DEFAULT_BANNER_TEXT =
    "In order to proceed to checkout, the minimum cart value must be Rs " +
    MINIMUM_CART_VALUE_DISPLAY +
    ".";

  /**
   * Update minimum cart value banner and checkout button state
   */
  function updateMinimumCartValueUI() {
    // Get cart total from the page
    var cartTotal = 0;
    var cartTotalElements = document.querySelectorAll(
      "[data-money-convertible]"
    );

    // Try to get cart total from various possible locations
    if (typeof window.theme !== "undefined" && window.theme.cart) {
      cartTotal = window.theme.cart.total_price || 0;
    } else {
      // Try to get from cart object if available
      if (typeof window.cart !== "undefined" && window.cart.total_price) {
        cartTotal = window.cart.total_price;
      } else {
        // Fallback: try to parse from displayed price
        var priceText = document.querySelector(
          ".Cart__Total .wholesale-original-price, .Cart__Total [data-money-convertible]"
        );
        if (priceText) {
          var priceMatch = priceText.textContent.match(/[\d,]+\.?\d*/);
          if (priceMatch) {
            // This is a fallback and may not be accurate, but better than nothing
            // The actual implementation should use cart API
            return; // Skip if we can't reliably get the total
          }
        }
      }
    }

    // Check if cart is below minimum
    var isBelowMinimum = cartTotal < MINIMUM_CART_VALUE;

    // Update checkout buttons
    var checkoutButtons = document.querySelectorAll(
      ".Cart__Checkout[data-minimum-cart-value]"
    );
    checkoutButtons.forEach(function (button) {
      if (isBelowMinimum) {
        button.disabled = true;
        button.style.opacity = "0.6";
        button.style.cursor = "not-allowed";
      } else {
        button.disabled = false;
        button.style.opacity = "";
        button.style.cursor = "";
      }
    });

    // Update banners
    var banners = document.querySelectorAll(".Cart__MinimumBanner");
    banners.forEach(function (banner) {
      if (isBelowMinimum) {
        banner.style.display = "block";
      } else {
        banner.style.display = "none";
      }
    });

    // If banner doesn't exist and cart is below minimum, create it
    if (isBelowMinimum && banners.length === 0) {
      createMinimumCartBanner();
    }
  }

  /**
   * Create minimum cart banner dynamically
   */
  function createMinimumCartBanner() {
    var checkoutButtons = document.querySelectorAll(
      ".Cart__Checkout[data-minimum-cart-value]"
    );
    checkoutButtons.forEach(function (button) {
      var container = button.closest(".Cart__Recap, .Drawer__Footer");
      if (container && !container.querySelector(".Cart__MinimumBanner")) {
        var banner = document.createElement("div");
        banner.className = "Cart__MinimumBanner Alert Alert--warning";
        banner.style.cssText =
          "margin-bottom: 15px; padding: 12px 15px; background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; color: #856404; font-size: 14px;";
        banner.innerHTML =
          '<p style="margin: 0;">' + DEFAULT_BANNER_TEXT + "</p>";
        container.insertBefore(banner, button);
      }
    });
  }

  /**
   * Fetch cart data and update UI
   */
  function fetchCartAndUpdate() {
    if (typeof fetch === "undefined") {
      // Fallback for older browsers
      if (typeof jQuery !== "undefined") {
        jQuery.getJSON("/cart.js", function (cart) {
          if (cart && cart.total_price !== undefined) {
            updateMinimumCartValueUIWithTotal(cart.total_price);
          }
        });
      }
      return;
    }

    fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (cart && cart.total_price !== undefined) {
          updateMinimumCartValueUIWithTotal(cart.total_price);
        }
      })
      .catch(function (error) {
        console.error("Error fetching cart:", error);
      });
  }

  /**
   * Update UI with known cart total
   */
  function updateMinimumCartValueUIWithTotal(cartTotal) {
    var isBelowMinimum = cartTotal < MINIMUM_CART_VALUE;

    // Update checkout buttons
    var checkoutButtons = document.querySelectorAll(
      ".Cart__Checkout[data-minimum-cart-value]"
    );
    checkoutButtons.forEach(function (button) {
      if (isBelowMinimum) {
        button.disabled = true;
        button.style.opacity = "0.6";
        button.style.cursor = "not-allowed";
      } else {
        button.disabled = false;
        button.style.opacity = "";
        button.style.cursor = "";
      }
    });

    // Update or create banners
    var banners = document.querySelectorAll(".Cart__MinimumBanner");
    if (isBelowMinimum) {
      if (banners.length === 0) {
        createMinimumCartBanner();
      } else {
        banners.forEach(function (banner) {
          banner.style.display = "block";
        });
      }
    } else {
      banners.forEach(function (banner) {
        banner.style.display = "none";
      });
    }
  }

  // Initialize on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      updateMinimumCartValueUI();
      // Also try to fetch cart data for more accurate updates
      setTimeout(fetchCartAndUpdate, 500);
    });
  } else {
    updateMinimumCartValueUI();
    setTimeout(fetchCartAndUpdate, 500);
  }

  // Listen for cart updates
  document.addEventListener("product:added", function () {
    setTimeout(fetchCartAndUpdate, 500);
  });

  // Listen for cart drawer updates (if using AJAX cart)
  var cartDrawer = document.getElementById("sidebar-cart");
  if (cartDrawer) {
    var observer = new MutationObserver(function (mutations) {
      setTimeout(fetchCartAndUpdate, 300);
    });
    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }

  // Listen for cart quantity changes
  document.addEventListener("click", function (e) {
    if (
      e.target.closest(
        '[data-action="update-item-quantity"], [data-action="remove-item"]'
      )
    ) {
      setTimeout(fetchCartAndUpdate, 500);
    }
  });

  // Also update when cart drawer is opened
  document.addEventListener("click", function (e) {
    if (
      e.target.closest(
        '[data-action="open-drawer"][data-drawer-id="sidebar-cart"]'
      )
    ) {
      setTimeout(fetchCartAndUpdate, 300);
    }
  });
})();
